import { Navigate, Route, Routes } from 'react-router-dom';

import { CompanyDetails } from './components/details/components/companyDetails/companyDetails';
import { UserDetails } from './components/details/components/userDetails/userDetails';
import {
  noCompanySelected,
  noContactSelected,
} from './components/details/utils/contactDetails.utils';
import { ContactsCompanies } from './components/sidebar/components/main/companies/contactsCompanies';
import { ContactsUsers } from './components/sidebar/components/main/users/contactsUsers';
import { ContactsView } from './contacts.view';

const ContactsUser = (
  <ContactsView list={<ContactsUsers />} details={<UserDetails />} />
);
const ContactsCompany = (
  <ContactsView list={<ContactsCompanies />} details={<CompanyDetails />} />
);

export const ContactsRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route index element={<Navigate to="user" replace />} />

      <Route path="user">
        <Route
          index
          element={
            <ContactsView
              list={<ContactsUsers />}
              details={noContactSelected}
            />
          }
        />

        <Route path=":id" element={ContactsUser} />
      </Route>

      <Route path="company">
        <Route
          index
          element={
            <ContactsView
              list={<ContactsCompanies />}
              details={noCompanySelected}
            />
          }
        />

        <Route path=":id" element={ContactsCompany} />
      </Route>
    </Routes>
  );
};
